import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_ROLE = createActionTypes('FETCH_ROLE');
export const GET_ROLE = createActionTypes('GET_ROLE');
export const CREATE_ROLE = createActionTypes('CREATE_ROLE');
export const UPDATE_ROLE = createActionTypes('UPDATE_ROLE');
export const DELETE_ROLE = createActionTypes('DELETE_ROLE');
export const MANAGE_ROLE = createActionTypes('MANAGE_ROLE');
export const GET_ROLE_BY_NAME = createActionTypes('GET_ROLE_BY_NAME');
